<div class="MainContainer">
  <div class="overlay" *ngIf="showInvoiceVisualizer;" (click)="showInvoiceVisualizer = false;"></div>

  <div class="MainTitleBar">
      <p class="SectionHalfTitle" style="margin-top: 0%;">
          {{ 'EFacturaReceivedInvoices' | translate }}
      </p>
  </div>
  
  <div class="MainTitleBar" style="overflow: hidden;">
      <div class="MainTitleBarIconContainer">
        <i class="material-icons">date_range</i>
      </div>
    
      <div class="FifteenPercentContainer">
        <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
          <mat-label>{{ 'Receptions.ChoosePeriod' | translate }}</mat-label>
          <mat-select name="Administration" [(ngModel)]="Filter.Period">
            <mat-option *ngFor="let a of this.Periods;" [value]="a" (click)="AddActiveFilter(a.Name, 'Period'); GetEFacturaReceivedInvoicesFromDocumentsDBFiltered();">
              {{a.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    
      <div class="MainTitleBarIconContainer">
        <i class="material-icons">date_range</i>
      </div>
    
      <div class="FifteenPercentContainer">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Receptions.FromDate' | translate }}</mat-label>
          <input matInput [matDatepicker]="dp" [formControl]="FromDate" [(ngModel)]="Filter.FromDate" (dateChange)="ClearPeriod()">
          <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
          <mat-datepicker #dp></mat-datepicker>
        </mat-form-field>
      </div>
    
      <div class="MainTitleBarIconContainer">
        <i class="material-icons">date_range</i>
      </div>
    
      <div class="FifteenPercentContainer">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Receptions.ToDate' | translate }}</mat-label>
          <input matInput [matDatepicker]="dp1" [formControl]="ToDate" [(ngModel)]="Filter.ToDate" (click)="DisablePeriod();" (dateChange)="ClearPeriod()">
          <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
          <mat-datepicker #dp1></mat-datepicker>
        </mat-form-field>
      </div>
    
      <div class="FifteenPercentContainer" style="margin-top: -4px;">
          <button mat-mini-fab aria-label="Example icon button with a home icon" color="primary" (click)="GetEFacturaReceivedInvoicesFromDocumentsDBFiltered();">
            <mat-icon>filter_alt</mat-icon>
          </button>
      </div>
    
  </div>
  
  <div class="MainTitleBar" style="overflow: unset;">
      <div class="FilterButton noselect" (click)="this.showFilter = !this.showFilter;">
          <i class="material-icons">filter_alt</i>
          <span>{{'Filter' | translate}}</span>
      </div>
  
      <div class="ActiveFiltersContainer">
        <div class="ActiveFilter" *ngFor="let a of this.activeFilters;" (click)="RemoveActiveFilter(a.ID, a.Type);">
          {{a.Name}}
          <i class="material-icons">close</i>
        </div>
      </div>
  
      <div class="FilterContainer animated fadeIn" *ngIf="showFilter">
          <div class="FilterCloseContainer" (click)="this.showFilter = false;">
              <i class="material-icons">close</i>
          </div>
  
          <div class="FilterContainerBody">
  
              <div class="PopUpBodyRow">
              </div>
               
              <div class="PopUpBodyOneThirddContainer">
                  <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                      <mat-label>{{ 'DocStatus' | translate }}</mat-label>
                      <mat-select name="Series" [(ngModel)]="Filter.Status">
                        <mat-option *ngFor="let d of this.EFacturaDownloadStatuses;" [value]="d" (click)="AddActiveFilter(d.Name, 'Status');">
                          {{d.Name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
              </div>
              
              <div class="PopUpBodyTwoThirdsContainer">
                  <mat-form-field appearance="outline" class="ReceptionProductsColDropDown">
                      <mat-label>{{ 'SearchProductInvoicesFilter' | translate }}</mat-label>
                      <input matInput placeholder="{{ 'SearchProductInvoicesFilter' | translate }}" autocomplete="off" [(ngModel)]="Filter.Product" (change)="AddActiveFilter('PN: ' + Filter.Product, 'Product');">
                  </mat-form-field>
              </div>
  
              <div class="PopUpBodyOneThirddContainer">
                
              </div>
  
              <div class="PopUpBodyTwoThirdsContainer">
                  <mat-form-field appearance="outline" style="width: 100%;padding: 0;" (click)="InitializePartnersOnClick(this.searchTerm, this.countryID, true);">
                      <mat-label>{{ 'SearchClient' | translate }}*</mat-label>
                      <input matInput placeholder="Name/VAT" autocomplete="off" [(ngModel)]="this.searchTerm" (ngModelChange)="this.searchPartnerUpdate.next($event)" (keydown.enter)="this.partner = Partners[0];resultsLength = 0;this.searchTerm = Partners[0].Name;this.Filter.Partner = Partners[0]?.Name; AddActiveFilter(Partners[0].Name, 'Partner');GetEFacturaReceivedInvoicesFromDocumentsDBFiltered();">
                      <mat-icon matSuffix (click)="GetPartnersFiltered(this.searchTerm, this.countryID, true);" style="cursor: pointer;" *ngIf="this.partner == null;">search</mat-icon>
                      <i class="material-icons searchCloseButton" *ngIf="this.searchTerm" (click)="this.searchTerm=''; this.Partners.length = 0;resultsLength = 0; this.partner = null; this.Filter.Partner = null;">close</i>
                  </mat-form-field>
  
                    <div class="PartnerSearchResultsContainer" *ngIf="resultsLength > 0;">
                      <div class="PartnerSearchResult" *ngFor="let p of Partners" (click)="this.partner = p;resultsLength = 0;this.searchTerm=p.Name;this.Filter.Partner = p.Name; AddActiveFilter(p.Name, 'Partner');">
                          <p class="SearchResultTitle DottedRow">{{p.Name}} <span style="font-weight: bold;" *ngIf="p.VAT?.length;">{{p.VAT}}</span></p>
                      </div>
                    </div>
              </div>
  
              <div class="PopUpBodyOneThirddContainer">
                 
              </div>
  
              <div class="PopUpBodyTwoThirdsContainer">
                  <mat-form-field appearance="outline" class="ReceptionProductsColDropDown">
                      <mat-label>{{ 'VATNumber' | translate }}</mat-label>
                      <input matInput placeholder="{{ 'VATNumber' | translate }}" autocomplete="off" [(ngModel)]="Filter.VATNumber" (change)="AddActiveFilter(Filter.VATNumber,'VATNumber');">
                    </mat-form-field>
              </div>
  
            <div class="PopUpBodyOneThirddContainer">
              
            </div>
  
              <div class="PopUpBodyTwoThirdsContainer">
                <mat-form-field appearance="outline" class="ReceptionProductsColDropDown">
                  <mat-label>{{ 'DocumentNumber' | translate }}</mat-label>
                  <input matInput placeholder="{{ 'DocumentNumber' | translate }}" autocomplete="off" [(ngModel)]="Filter.DocumentNumber" (change)="AddActiveFilter(Filter.DocumentNumber,'DocumentNumber');">
                </mat-form-field>
              </div>
  
              <div class="PopUpBodyOneThirddContainer">
             
              </div>
          </div>
          
          <div class="FilterCommands">
              <button mat-raised-button color="primary" class="FilterButtonAction" (click)="GetEFacturaReceivedInvoicesFromDocumentsDBFiltered();">{{ 'FilterInvoices' | translate }}</button>
          </div>
      </div>
  
      <div class="TotalDocCountContainer">
        <span style="float: right;">{{this.Invoices?.length}} {{'OfWord' | translate}} {{this.Filter.Pager.TotalCount}} {{'Invoices' | translate}} ({{'Page' | translate}}: {{this.Filter.Pager.PageIndex}} {{'OfWord' | translate}} {{this.Filter.Pager.Pages}})</span>
        <div class="PageSizeContainer">
          <mat-form-field appearance="outline" class="PageSizeTextBox">
            <mat-label>{{ 'PageSize' | translate }}*</mat-label>
            <input matInput autocomplete="off" [(ngModel)]="Filter.Pager.PageSize" (change)="GetEFacturaReceivedInvoicesFromDocumentsDBFiltered(1);">
          </mat-form-field>
        </div>
      </div>
  
      <div class="TotalDocCountContainer">
        <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex != 1;" (click)="GetEFacturaReceivedInvoicesFromDocumentsDBFiltered(this.Filter.Pager.PageIndex - 1);">
          <i class="material-icons">chevron_left</i>
        </div>
        <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex == 1;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
          <i class="material-icons">chevron_left</i>
        </div>
  
        <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex != this.Filter.Pager.Pages;" (click)="GetEFacturaReceivedInvoicesFromDocumentsDBFiltered(this.Filter.Pager.PageIndex + 1);">
          <i class="material-icons">chevron_right</i>
        </div>
        <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
          <i class="material-icons">chevron_right</i>
        </div>
      </div>
  </div>
  
  <div class="MainBody">
  
      <div class="ReceptionProductsContainer">
        
          <div class="ReceptionProductsHeadder ReceptionProductsRow" style="border: none;">
              <div class="ReceptionProductsCol" style="width: 2.5%;">
                <mat-checkbox class="tableColCheckBox" [(ngModel)]="AllSelected" (change)="SelectAll();"></mat-checkbox>
              </div>
              <div class="ReceptionProductsCol" style="width: 7.5%;">
                {{ 'Receptions.Table.Nr' | translate }}
              </div>
              <div class="ReceptionProductsCol" style="width: 20%;padding-left: 20px;text-align: left;cursor: pointer;">
                {{ 'Supplier' | translate }}
              </div>
              <div class="ReceptionProductsCol" style="width: 10%;padding-left: 20px;text-align: left;cursor: pointer;">
                {{ 'VATNumber' | translate }}
              </div>
              <div class="ReceptionProductsCol" style="width: 15%;">
                  {{ 'CreatingDate' | translate }}
              </div>
              <div class="ReceptionProductsCol" style="width: 7.5%;">
                  Total
              </div>
              <div class="ReceptionProductsCol" style="width: 5%;">
                  {{ 'Currency' | translate }}
              </div>
              <div class="ReceptionProductsCol" style="width: 17.5%;">
                {{ 'Document' | translate }}
              </div>
              <div class="ReceptionProductsCol" style="width: 7.5%;">
                  {{ 'Status' | translate }}
                </div>
              <div class="ReceptionProductsCol" style="width: 7.5%;">
                {{ 'Actions' | translate }}
              </div>
          </div>
  
          <div class="ReceptionProductsRow TotalRow" *ngIf="loading">
              <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
          </div>
  
        <div *ngIf="!loading">
          <div [ngClass]="{'deactivatedReception': i.EFacturaDownloadStatus == -1, 'ObservationPadding': i.EFacturaMessage?.detalii?.length > 0 }" class="ReceptionProductsRow ReceptionProductsRowHover" style="border: none;" *ngFor="let i of this.Invoices; let j=index;">
            <div class="ReceptionProductsCol" style="width: 2.5%;">
              <mat-checkbox class="tableColCheckBox" [(ngModel)]="i.IsSelected" (change)="CheckIfAnyChecked();"></mat-checkbox>
            </div>
            <div class="ReceptionProductsCol" style="width: 7.5%;">
              {{j + 1}}
            </div>
            <div class="ReceptionProductsCol" style="width: 20%;padding-left: 20px;text-align: left;cursor: pointer;">
              {{i.Partner}}
            </div>
            <div class="ReceptionProductsCol" style="width: 10%;padding-left: 20px;text-align: left;cursor: pointer;">
              {{i.VATNumber}}
            </div>
            <div class="ReceptionProductsCol" style="width: 15%;">
              {{i.EventRegisterUI}}
            </div>
            <div class="ReceptionProductsCol" style="width: 7.5%;">
              {{i.Price}}
            </div>
            <div class="ReceptionProductsCol" style="width: 5%;">
              {{i.Currency}}
            </div>
            <div class="ReceptionProductsCol" style="width: 17.5%;">
              {{i.DocumentNumber}}
            </div>
            <div class="ReceptionProductsCol" style="width: 7.5%;">
                {{i.EFacturaDownloadStatus}}
              </div>
            <div class="ReceptionProductsCol" style="width: 7.5%;">
              
            </div>
        </div>
        </div>

        <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow" *ngIf="!loading && Invoices.length > 0;">
          <div class="ReceptionProductsCol" style="width: 10%;">
    
          </div>
          <div class="ReceptionProductsCol" style="width: 20%;">
          </div>
          <div class="ReceptionProductsCol" style="width: 10%;text-align: left;padding-left: 1%;">
          </div>
          <div class="ReceptionProductsCol totalCol" style="width: 10%;">
            <button mat-raised-button *ngIf="this.Filter.Pager.PageIndex != 1;" (click)="GetEFacturaReceivedInvoicesFromDocumentsDBFiltered(this.Filter.Pager.PageIndex - 1);">
              <i class="material-icons">chevron_left</i>
            </button>
    
            <button mat-raised-button *ngIf="this.Filter.Pager.PageIndex == 1;" style="background: #eee;cursor: not-allowed;">
              <i class="material-icons">chevron_left</i>
            </button>
          </div>
          <div class="ReceptionProductsCol totalCol" style="width: 10%;">
            {{this.Filter.Pager.PageIndex}} / {{this.Filter.Pager.Pages}}
          </div>
          <div class="ReceptionProductsCol totalCol" style="width: 10%;">
            <button mat-raised-button *ngIf="this.Filter.Pager.PageIndex != this.Filter.Pager.Pages;" (click)="GetEFacturaReceivedInvoicesFromDocumentsDBFiltered(this.Filter.Pager.PageIndex + 1);">
              <i class="material-icons">chevron_right</i>
            </button>
    
            <button mat-raised-button *ngIf="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages;" style="background: #eee;cursor: not-allowed;">
              <i class="material-icons">chevron_right</i>
            </button>
          </div>
          <div class="ReceptionProductsCol totalCol" style="width: 10%;">
              
          </div>
          <div class="ReceptionProductsCol totalCol" style="width: 10%;">
              
          </div>
          <div class="ReceptionProductsCol" style="width: 10%;">
              
          </div>
      </div>
      </div>
  </div>
</div>

